/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ContributedOfferShort = {
    id: string;
    order: number;
    name: string;
    description: string;
    miles: number;
    imageMetadataId: string;
    isParticipation?: boolean;
    type?: ContributedOfferShort.type;
};

export namespace ContributedOfferShort {

    export enum type {
        SINGLE = 'SINGLE',
        PARTICIPATION = 'PARTICIPATION',
        BASE_SPENT = 'BASE_SPENT',
    }


}

